import { Checkbox, Paragraph, tokens } from '@welbe/web-design-system';
import React, { useContext, useRef } from 'react';
import { FiChevronRight } from 'react-icons/fi';
import { Header, HeaderActions, InfoCard } from './AccordionItem.styles';
import { BiInfoCircle } from 'react-icons/bi';
import { JobProfileContext } from 'Views/JobProfile/JobProfile.context';

type AccordionItemProps = {
	onSelectHeader: (id: number) => void;
	onCheckItem: (state: boolean, id: string, riskNumber: number) => void;
	active: number;
	item: {
		id: number;
		name: string;
		description: string;
		isChecked?: boolean;
		jobProfileRiskFactor: {
			id: string;
		};
	};
};

export const AccordionItem = ({
	item,
	active,
	onCheckItem,
	onSelectHeader,
}: AccordionItemProps) => {
	const { jobRiskFactorsError } = useContext(JobProfileContext);

	const contentEl = useRef<HTMLDivElement>(null);
	const { name, id, description, isChecked, jobProfileRiskFactor } = item;
	const isActive = active === id;

	const hasError = () =>
		!!jobRiskFactorsError
			.find((factor) => factor.id === jobProfileRiskFactor.id)
			?.jobExamProfileRiskFactors.some((exam) => exam.frequency || exam.type);

	return (
		<div>
			<Header active={isActive}>
				<Checkbox
					id={`risk-${id}`}
					value={isChecked || false}
					topDistance="3px"
					onChange={(state) => onCheckItem(state, jobProfileRiskFactor.id, id)}
				/>
				<HeaderActions active={isActive} onClick={() => onSelectHeader(id)}>
					<Paragraph
						margin="10px 0"
						fontSize="16px"
						fontWeight="600"
						elipsis
						width="290px"
						title={name}
						color={hasError() ? tokens.color_danger : tokens.color_primary}
					>
						{name}
					</Paragraph>
					<FiChevronRight
						size="20px"
						color={hasError() ? tokens.color_danger : tokens.color_primary}
					/>
				</HeaderActions>
			</Header>
			{description && (
				<InfoCard ref={contentEl} active={isActive}>
					<BiInfoCircle size="20px" color={tokens.color_primary} />
					<Paragraph fontSize="12px" fontWeight="500">
						{description}
					</Paragraph>
				</InfoCard>
			)}
		</div>
	);
};
